import React from "react";
import { MaterialReactTable } from "material-react-table";
import { sharedTableProps } from "../shared/tableProps";
import AddToolbarLink from "../shared/AddToolbarLink";

const EIConnectionViewTable = ({ data, mainColumns }) => (
  <MaterialReactTable
    {...sharedTableProps}
    columns={mainColumns}
    data={data}
    initialState={{ density: "compact" }}
    muiTableContainerProps={{ sx: { maxHeight: "600px" } }}
    renderTopToolbarCustomActions={() => (
      <AddToolbarLink to="/AddEIConnection" label="Add Connection" />
    )}
  />
);

export default EIConnectionViewTable;
